import { ObjectKey } from "../types/pills";
import { formatPills } from "./pillsFormat";

export const formatSpecs = (specs: ObjectKey<string>): string => {
  const resp = formatPills({ pillsList: specs });

  const pillsArray = resp?.pills?.filter(pill => !/Cargo|Perfil/i?.test(pill?.name))?.slice(0, 3) || [];

  const pillsString = pillsArray?.map(pill => `${pill?.value}`).join(' - ');

  return pillsString || 'No hay pills';
};
